import React from "react";

import { BridgeContextProvider } from "./context/BridgeContext";
import { ProfileContextProvider } from "./context/ProfileContext";
import { ConfigContextProvider } from './context/ConfigContext';
import { AccountContextProvider } from "./context/AccountContext";
import { TourProvider } from "./context/TourContext";
const ContextWrapper = ({ children }) => {
  return (
    <TourProvider>
      <ProfileContextProvider>
        <ConfigContextProvider>
          <AccountContextProvider>
            <BridgeContextProvider>
              {children}
            </BridgeContextProvider>
          </AccountContextProvider>

        </ConfigContextProvider>

      </ProfileContextProvider>
    </TourProvider>

  );
};

export default ContextWrapper;